// extracted by mini-css-extract-plugin
export default {"wrapper":"loading-overlay_wrapper__IpqJg","background":"loading-overlay_background__WsAlF"};